/*!
 *
 * TruckxiSCM
 *
 * Version: 0.0.2
 * Author: @geno_diaz
 * E-mail: GenoCDiaz@gmail.com
 *
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Link, hashHistory, browserHistory, IndexRoute } from 'react-router';

import initTranslation from './components/Common/localize';
import initLoadCss from './components/Common/load-css';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';

import { loadTranslations, setLocale, syncTranslationWithStore, i18nReducer } from 'react-redux-i18n';

import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
import BaseHorizontal from './components/Layout/BaseHorizontal';

import Users from './containers/Users/users';
import UserForm from './containers/Users/userForm';
import Products from './containers/Products/products';
import ProductForm from './containers/Products/productForm';
import Groups from './containers/Products/groups';
import Categories from './containers/Products/categories';
import Customers from './containers/Customers/customers';
import CustomerForm from './containers/Customers/customerForm';
import Vendors from './containers/Vendors/vendors';
import VendorDetailForm from './containers/Vendors/vendorDetailForm';
import Agents from './containers/Agents/agents';
import AgentForm from './containers/Agents/agentForm';
import PriceLevel from './containers/Products/priceLevel';
import PaymentTerms from './containers/PaymentTerms/paymentTerms';
import Packers from './containers/General/Packers';

import GeneralDashboard from './containers/General/generalDashboardRevision';
import GeneralDashboardVAK from './components/General/generalDashboardVAK';
import CategoryAnalysis from './containers/General/CategoryAnalysis';
import PresidentDashboard from './containers/Purchase/presidentDashboard';
import PurchaseDashboard from './containers/Purchase/purchaseDashboard';
import PurchaseManagerDashboard from './containers/Purchase/purchaseManagerDashboard';
import WarehouseDashboard from './containers/Purchase/warehouseDashboard';
import SalesDashboard from './containers/Sales/salesDashboard';
import PurchaseQuoteList from './containers/Purchase/purchaseQuoteList';
import PurchaseTemplateList from './containers/Purchase/purchaseTemplateList';
import PurchaseScheduleList from './containers/Purchase/purchaseScheduleList';
import PurchaseReturnList from './containers/Purchase/purchaseReturnList';
import PurchaseOrderList from './containers/Purchase/purchaseOrderList';
import PurchaseQuoteForm from './containers/Purchase/purchaseQuoteForm';
import PurchaseScheduleForm from './containers/Purchase/purchaseScheduleForm';
import PurchaseTemplateForm from './containers/Purchase/purchaseTemplateForm';
import PurchaseOrderForm from './containers/Purchase/purchaseOrderForm';
import PurchaseReturnForm from './containers/Purchase/purchaseReturnForm';
import PurchasingPerformance from './containers/Purchase/purchasingPerformance';
import PriceAdjustmentReport from './containers/Purchase/priceAdjustment';
import PriceAdjustmentDetail from './containers/Purchase/priceAdjustmentDetail';
import PurchasePaymentList from './containers/Purchase/purchasePaymentList';
import PurchasePaymentDetail from './containers/Purchase/purchasePaymentDetail';
import PurchasePivotChartDetail from './containers/Purchase/purchasePivotChartDetail';
import PurchasePivotChart from './containers/Purchase/purchasePivotChart';
import PurchaseReferenceReport from './containers/Purchase/purchaseReference';

import Inventories from './containers/Inventories/inventories';
import InventoryDetail from './containers/Inventories/inventoryDetail';
import InventoryLowStock from './containers/Inventories/inventoryLowStock';
import InventoryExpired from './containers/Inventories/inventoryExpired';
import InventoryAdjustments from './containers/Inventories/inventoryAdjustments';
import InventoryAdjustmentForm from './containers/Inventories/inventoryAdjustmentForm';
import InventoryRelocations from './containers/Inventories/inventoryRelocations';
import InventoryRelocationForm from './containers/Inventories/inventoryRelocationForm';
import InventoryRelocationFromInbound from './containers/Inventories/inventoryRelocationFromInbound';
import InventoryRepackages from './containers/Inventories/inventoryRepackages';
import InventoryRepackageForm from './containers/Inventories/inventoryRepackageForm';
import InventoryConverts from './containers/Inventories/inventoryConverts';
import InventoryConvertForm from './containers/Inventories/inventoryConvertForm';
import ScrapRecords from './containers/Inventories/scrapRecords';
import ScrapRecordForm from './containers/Inventories/scrapRecordForm';
import PutAway from './containers/Inventories/putAway';
import PutAwayForm from './containers/Inventories/putAwayForm';
import InboundForm from './containers/Inventories/inboundForm';
import ReceiveList from './containers/Inventories/receiveList';
import ReceiveForm from './containers/Inventories/receiveForm';
import ReceiveHistoryList from './containers/Inventories/receiveHistoryList';
import ReceiveHistoryDetail from './containers/Inventories/receiveHistoryDetail';

import Warehouses from './containers/Inventories/warehouses';
import WarehouseForm from './containers/Inventories/warehouseForm';
import WarehouseDetail from './containers/Inventories/warehouseDetail';
import ZoneForm from './containers/Inventories/zoneForm';
import ZoneDetail from './containers/Inventories/zoneDetail';
import BinForm from './containers/Inventories/binForm';
import BinDetail from './containers/Inventories/binDetail';
import ProductConvertReport from './containers/Inventories/productConvert';
import ProductConvertDetail from './containers/Inventories/productConvertDetail';

import SalesOrders from './containers/Sales/salesOrders';
import PosOrders from './containers/Sales/posOrders';
import PosCredits from './containers/Sales/posCredits';
import PosHolds from './containers/Sales/posHolds';
import SalesOrderForm from './containers/Sales/salesOrderForm';
import Wholesale from './containers/Sales/wholesale';
import WholesaleOrderForm from './containers/Sales/wholesaleOrderForm';
import FavoriteList from './containers/Sales/favoriteList';
import GroupList from './containers/Sales/groupList';
import SalesInvoice from './containers/Sales/salesInvoice';
import EditSalesInvoice from './containers/Sales/editSalesInvoice';
import ViewPosOrder from './containers/Sales/viewPosOrder';
import PromotionsPage from './containers/Sales/PromotionsPage';
import PosReport from './containers/Sales/posReport';
import SalesPerformanceReport from './containers/Sales/salesPerformance';

import Shipping from './containers/Dispatch/shipping';
import Routing from './containers/Dispatch/routing';
import EditRoutes from './containers/Dispatch/editRoutes';
import Drivers from './containers/Dispatch/Drivers';
import AutoRouting from './containers/Dispatch/AutoRouting';

import ARList from './containers/AR/ARList';
import ARDetail from './containers/AR/ARDetail';
import CreateAR from './containers/AR/createAR';
import EditAR from './containers/AR/editAR';
import APList from './containers/AP/APList';
import APDetail from './containers/AP/APDetail';
import CreateAP from './containers/AP/createAP';
import EditAP from './containers/AP/editAP';
import SIPaymentList from './containers/AR/SIPaymentList';
import SIPaymentForm from './containers/AR/SIPaymentForm';
import GeneralReport from './containers/AR/generalReport';
import MobileCustomerStatement from './containers/AR/mobileCustomerStatement';
import CustomerStatement from './containers/AR/customerStatement';
import CustomerStatementMain from './containers/AR/customerStatementMain';
import VendorStatement from './containers/AP/vendorStatement';
import VendorStatementMain from './containers/AP/vendorStatementMain';
import CityReport from './containers/AR/cityReport';

import UserManagement from './containers/Settings/userManagement';
import UserManagementDetail from './containers/Settings/userManagementDetail';
import GroupManagement from './containers/Settings/groupManagement';
import GroupManagementDetail from './containers/Settings/groupManagementDetail';
import TaxManagement from './containers/Settings/taxManagement';
import CurrencyManagement from './containers/Settings/currencyManagement';
import AgentManagement from './components/Agents/AgentManagement';
import { PriceAdjustment, ProductConvert, PurchasePivot, PurchaseReference,
  PurchasePerformance, SalesPerformance, POSPicture } from './components/Report/report';
import ActionLog from './containers/Settings/ActionLog';

import CustomerReturn from './containers/Returns/customerReturn';
import CustomerReturnForm from './containers/Returns/customerReturnForm';
import CustomerIssueCredit from './containers/Returns/customerIssueCredit';
import RestockReturnForm from './containers/Returns/restockReturnForm';
import CreditForm from './containers/Returns/creditForm';
import InventoryReturn from './containers/Returns/inventoryReturn';

import MobileManagement from './containers/General/MobileManagement';
import AdjustmentInventory from "./containers/Inventories/adjustmentInventory";
import rmaForm from "./containers/RMA/rmaForm";
import customerRMA from "./containers/RMA/rma";
import dispatchRMA from "./containers/RMA/rma";
import GLList from './components/GL/GLOrderListContainer';

import Login from './containers/Auth/login';
import Signup from './containers/Auth/signup';
import RequireAuth from './containers/Auth/require_auth'
import UserBasedAuthentication from './containers/Auth/userBased_auth';
import reducers, { rootEpic } from './reducers';
import { createEpicMiddleware } from 'redux-observable';
import reduxThunk from 'redux-thunk';
// import createLogger from 'redux-logger';

import { checkStatues } from './actions/auth_actions';
import { AUTH_USER } from './actions/type';
import {Translate} from 'react-redux-i18n'
import { Button } from 'react-bootstrap';

// Import Translation files
import chMessages from '../i18n/ch.json';
import enMessages from '../i18n/en.json';

import MMdriver from './containers/MMdriver';
import SalesQuotes from './containers/Sales/salesQuotes';
import SalesQuoteForm from './containers/Sales/salesQuoteForm';

import MarketingForm from './containers/marketing/marketing'
import {isGGI, isVAK} from './actions/root_url'

// Init translation system
initTranslation();
// Init css loader (for themes)
initLoadCss();

const epicMiddleware = createEpicMiddleware(rootEpic);

const configureStore = (state, middleware) => {
  const response = createStore(reducers, state, middleware);

  return response;
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const middlewares = [reduxThunk, createLogger({ collapsed: true })];
const middlewares = [reduxThunk, epicMiddleware];
const middleware = composeEnhancers(applyMiddleware(...middlewares));

// const middlewares = [thunk, router, ReduxPromise];

const store = configureStore({}, middleware);
// const createStoreWithMiddleware = applyMiddleware(middleware)();
// const store = createStoreWithMiddleware(reducers);

var translationsObject = {}
translationsObject.en = enMessages;
translationsObject.ch = chMessages;
syncTranslationWithStore(store);
store.dispatch(loadTranslations(translationsObject));
store.dispatch(setLocale('en'));

// Check
const token = localStorage.getItem('token');
const user = localStorage.getItem('userType');
// if (token) {
//     store.dispatch(checkStatues());
// }

const Root = React.createClass({
    // Refresh function, not suggested to be used, may cause some issue.

    childContextTypes: {
        refresh: React.PropTypes.func
    },

    getChildContext() {
        return {
            refresh: () => this.forceUpdate()
        };
    },

    render() {
        return (
            <Provider store={store}>
                <div>
         <Router
                  history={browserHistory}
                >

                    <Route path="/" component={RequireAuth(Base)}>

                        {/* Default route*/}
                        <IndexRoute component={(isVAK ? GeneralDashboardVAK : GeneralDashboard)} />

                        <Route path="dashboard" component={(isVAK ? GeneralDashboardVAK : GeneralDashboard)} />
                        <Route path="generaldashboard" component={(GeneralDashboard)} />
                        <Route path="purchaseManagerDashboard" component={(PurchaseManagerDashboard)} />
                        <Route path="presidentDashboard" component={(PresidentDashboard)} />
                        <Route path="categoryAnalysis" component={(CategoryAnalysis)} />
                        <Route path="warehouse" component={(WarehouseDashboard)} />
                        <Route path="sales" component={(SalesDashboard)} />

                        <Route path="users" component={(Users)} />
                        <Route path="users/new" component={(UserForm)} />
                        <Route path="users/:id" component={(UserForm)} />
                        <Route path="customers" component={(Customers)} />
                        <Route path="customers/new" component={(CustomerForm)} />
                        <Route path="customers/:id" component={(CustomerForm)} />
                        <Route path="products" component={(Products)} />
                        <Route path="products/new" component={(ProductForm)} />
                        <Route path="products/groups" component={(Groups)} />
                        <Route path="products/categories" component={(Categories)} />
                        <Route path="products/:id" component={(ProductForm)} />
                        <Route path="marketing" component={(MarketingForm)} />
                        <Route path="vendors" component={(Vendors)} />
                        <Route path="vendors/new" component={(VendorDetailForm)} />
                        <Route path="vendors/:id" component={(VendorDetailForm)} />
                        <Route path="agents" component={(Agents)} />
                        <Route path="agents/new" component={(AgentForm)} />
                        <Route path="agents/:id" component={(AgentForm)} />
                        <Route path="priceLevel" component={(PriceLevel)} />
                        <Route path="paymentTerms" component={(PaymentTerms)} />
                        <Route path="packers" component={(Packers)} />

                        <Route path="purchase" component={(PurchaseDashboard)} />
                        <Route path="purchaseQuote" component={(PurchaseQuoteList)} />
                        <Route path="purchaseQuote/new" component={(PurchaseOrderForm)} />
                        <Route path="purchaseQuote/:id" component={(PurchaseOrderForm)} />
                        <Route path="purchaseTemplate" component={(PurchaseTemplateList)} />
                        <Route path="purchaseTemplate/new" component={(PurchaseOrderForm)} />
                        <Route path="purchaseTemplate/:id" component={(PurchaseOrderForm)} />
                        <Route path="purchaseSchedule" component={(PurchaseScheduleList)} />
                        <Route path="purchaseSchedule/new" component={(PurchaseScheduleForm)} />
                        <Route path="purchaseSchedule/:id" component={(PurchaseScheduleForm)} />
                        <Route path="purchaseReturn" component={(PurchaseReturnList)} />
                        <Route path="purchaseReturn/new" component={(PurchaseReturnForm)} />
                        <Route path="purchaseReturn/newCredit" component={(PurchaseReturnForm)} />
                        <Route path="purchaseReturn/:id" component={(PurchaseReturnForm)} />
                        <Route path="purchaseOrder" component={(PurchaseOrderList)} />
                        <Route path="purchaseOrderQuote" component={(PurchaseOrderList)} />
                        <Route path="dropshipOrder" component={(PurchaseOrderList)} />
                        <Route path="purchaseOrder/new" component={(PurchaseOrderForm)} />
                        <Route path="purchaseOrder/:id" component={(PurchaseOrderForm)} />
                        <Route path="purchasingPerformanceReport" component={(PurchasingPerformance)} />
                        <Route path="priceAdjustmentReport" component={(PriceAdjustmentReport)} />
                        <Route path="priceAdjustmentDetail" component={(PriceAdjustmentDetail)} />
                        <Route path="purchasePayment" component={(PurchasePaymentList)} />
                        <Route path="purchasePayment/:id" component={(PurchasePaymentDetail)} />
                        <Route path="purchasePivotChart" component={(PurchasePivotChart)} />
                        <Route path="purchasePivotChart/:id" component={(PurchasePivotChartDetail)} />
                        <Route path="purchasePivotChart/new" component={(PurchasePivotChartDetail)} />
                        <Route path="purchaseReferenceReport" component={(PurchaseReferenceReport)} />


                        <Route path="salesOrders" component={(SalesOrders)} />
                        <Route path="salesOrders/new" component={(SalesOrderForm)} />
                        <Route path="salesOrders/:id" component={(SalesOrderForm)} />
                        <Route path="salesQuotes" component={(SalesQuotes)} />
                        <Route path="salesQuotes/new" component={(SalesQuoteForm)} />
                        <Route path="salesQuotes/:id" component={(SalesQuoteForm)} />
                        <Route path="outboundOrders" component={(SalesOrders)} />
                        <Route path="outboundOrders/new" component={(SalesOrderForm)} />
                        <Route path="outboundOrders/:id" component={(SalesOrderForm)} />
                        <Route path="mobileSalesOrders" component={(SalesOrders)} />
                        <Route path="mobileSalesOrders/new" component={(SalesOrderForm)} />
                        <Route path="mobileSalesOrders/:id" component={(SalesOrderForm)} />
                        <Route path="wholesale" component={(Wholesale)} />
                        <Route path="wholesale/new" component={(WholesaleOrderForm)} />
                        <Route path="favoriteList" component={(FavoriteList)} />
                        <Route path="groupList" component={(GroupList)} />
                        <Route path="promotions" component={(PromotionsPage)} />
                        <Route path="salesInvoice" component={(SalesInvoice)} />
                        <Route path="salesInvoice/:id" component={(EditSalesInvoice)} />
                        {/* <Route path="pos" component={(Pos)} /> */}
                        <Route path="pos" component={POSPicture} />
                        <Route path="posReport" component={(PosReport)} />
                        <Route path="posOrders" component={(PosOrders)} />
                        <Route path="posOrders/:id" component={(ViewPosOrder)} />
                        <Route path="posCredits" component={(PosCredits)} />
                        <Route path="SalesPerformanceReport" component={(SalesPerformanceReport)} />
                        <Route path="posHolds" component={(PosHolds)} />


                        <Route path="inventories" component={(Inventories)} />
                        <Route path="inventories/detail" component={(InventoryDetail)} />
                        <Route path="inventories/detail/:id" component={(InventoryDetail)} />
                        <Route path="inventories/lowStock" component={(InventoryLowStock)} />
                        <Route path="inventories/expired" component={(InventoryExpired)} />
                        <Route path="inventories/repackage" component={(InventoryRepackages)} />
                        <Route path="inventories/repackage/new" component={(InventoryRepackageForm)} />
                        <Route path="inventories/repackage/:id" component={(InventoryRepackageForm)} />
                        <Route path="inventories/convert" component={(InventoryConverts)} />
                        <Route path="inventories/convert/new" component={(InventoryConvertForm)} />
                        <Route path="inventories/convert/:id" component={(InventoryConvertForm)} />
                        <Route path="inventories/receive" component={(ReceiveList)} />
                        <Route path="inventories/receive/:id" component={(ReceiveForm)} />
                        <Route path="inventories/receive/new" component={(ReceiveForm)} />
                        <Route path="inventories/receiveHistory" component={(ReceiveHistoryList)} />
                        <Route path="inventories/receiveHistory/:id" component={(ReceiveHistoryDetail)} />
                        <Route path="inventories/relocation" component={(InventoryRelocations)} />
                        <Route path="inventories/relocation/new" component={(InventoryRelocationForm)} />
                        <Route path="inventories/relocation/:id" component={(InventoryRelocationForm)} />
                        <Route path="inventories/relocation/inbound" component={(InventoryRelocationFromInbound)} />
                        <Route path="inventories/adjustment" component={(InventoryAdjustments)} />
                        <Route path="inventories/adjustment/new" component={(InventoryAdjustmentForm)} />
                        <Route path="inventories/adjustment/:id" component={(InventoryAdjustmentForm)} />

                        <Route path="scrapRecords" component={(ScrapRecords)} />
                        <Route path="scrapRecords/new" component={(ScrapRecordForm)} />
                        <Route path="scrapRecords/:id" component={(ScrapRecordForm)} />
                        <Route path="putAway" component={(PutAway)} />
                        <Route path="putAway/new" component={(PutAwayForm)} />
                        <Route path="putAway/inbound" component={(InboundForm)} />
                        <Route path="putAway/:id" component={(PutAwayForm)} />
                        <Route path="warehouses" component={(Warehouses)} />
                        <Route path="warehouses/form" component={(WarehouseForm)} />
                        <Route path="warehouses/detail" component={(WarehouseDetail)} />
                        <Route path="zoneForm" component={(ZoneForm)} />
                        <Route path="zoneDetail" component={(ZoneDetail)} />
                        <Route path="binForm" component={(BinForm)} />
                        <Route path="binDetail" component={(BinDetail)} />
                        <Route path="productConvertReport" component={(ProductConvertReport)} />
                        <Route path="productConvertReport/new" component={(ProductConvertDetail)} />
                        <Route path="adjustmentInventory" component={AdjustmentInventory}/>

                        <Route path="mobileManagement" component={(MobileManagement)} />

                        <Route path="rmaForm" component={(rmaForm)} />
                        <Route path="customerRMA" component={(customerRMA)} />
                        <Route path="customerRMA/new" component={(rmaForm)} />
                        <Route path="dispatchRMA" component={(dispatchRMA)} />
                        <Route path="dispatchRMA/:id" component={(rmaForm)} />
                        <Route path="customerRMA/:id" component={(rmaForm)} />

                        <Route path="shipping" component={(Shipping)} />
                        <Route path="routing" component={(Routing)} />
                        <Route path="autorouting" component={(AutoRouting)} />
                        <Route path="editRoutes" component={(EditRoutes)} />
                        <Route path="drivers" component={(Drivers)} />

                        <Route path="customerReturn" component={(CustomerReturn)} />
                        <Route path="customerReturn/new" component={(CustomerReturnForm)} />
                        <Route path="customerReturn/:id" component={(CustomerReturnForm)} />
                        <Route path="customerIssueCredit" component={(CustomerIssueCredit)} />
                        <Route path="restockReturn/:id" component={(RestockReturnForm)} />
                        <Route path="customerCredit/new" component={(CreditForm)} />
                        <Route path="customerCredit/:id" component={(CreditForm)} />
                        <Route path="inventoryReturn" component={(InventoryReturn)} />
                        <Route path="AR" component={(ARList)} />
                        <Route path="AR/new" component={(CreateAR)} />
                        <Route path="AR/:id" component={(EditAR)} />
                        <Route path="AP" component={(APList)} />
                        <Route path="AP/new" component={(CreateAP)} />
                        <Route path="AP/:id" component={(EditAP)} />
                        <Route path="arSalesInvoice" component={(SalesInvoice)} />
                        <Route path='salesInvoicePayment' component={(SIPaymentList)} />
                        <Route path='salesInvoicePayment/:id' component={(SIPaymentForm)} />
                        <Route path="generalReport" component={(GeneralReport)} />
                        <Route path="customerStatement" component={(CustomerStatement)} />
                        <Route path="customerStatementMain" component={(CustomerStatementMain)} />
                        <Route path="vendorStatement" component={(VendorStatement)} />
                        <Route path="vendorStatementMain" component={(VendorStatementMain)} />
                        <Route path='mobileCustomerStatement' component={(MobileCustomerStatement)} />
                        <Route path='cityReport' component={(CityReport)} />

                        <Route path="glList" component={(GLList)} />
                        
                        <Route path="userManagement" component={(UserManagement)} />
                        <Route path="userManagement/:id" component={(UserManagementDetail)} />
                        <Route path="userManagement/new" component={(UserManagementDetail)} />
                        <Route path="groupManagement" component={(GroupManagement)} />
                        <Route path="groupManagement/new" component={(GroupManagementDetail)} />
                        <Route path="groupManagement/:id" component={(GroupManagementDetail)} />
                        <Route path="taxManagement" component={(TaxManagement)} />
                        <Route path="currencyManagement" component={(CurrencyManagement)} />
                        <Route path="agentManagement" component={(AgentManagement)} />
                        <Route path="actionLog" component={(ActionLog)} />

                        <Route path="priceAdjustment" component={PriceAdjustment} />
                        <Route path="productConvert" component={ProductConvert} />
                        <Route path="purchasePivot" component={PurchasePivot} />
                        <Route path="purchaseReference" component={PurchaseReference} />
                        <Route path="purchasePerformance" component={PurchasePerformance} />
                        <Route path="salesPerformance" component={SalesPerformance} />

                        <Route path="mmdriver" component={MMdriver} />
                    </Route>
                    <Route path="/login" component={Login} />
                    <Route path="/signup" component={Signup} />
                    {/* Not found handler */}
                    {/*<Route path="*" component={NotFound}/>*/}
                </Router>
                {isGGI && <div id='tokenInvalid' style={{display:'none',flexDirection:'column',width:450, height:150, padding:20, position:'absolute', top:20,left:'50%',backgroundColor:'white',zIndex:10000, borderRadius:8}}>
                    <span>You have been logged out because you signed in on another device.</span>
                    <div style={{width:80, height:40, position:'absolute', top:100,right:20}}>
                    <Button
                        variant="primary"
                        onClick={() => { 
                            document.getElementById('tokenInvalid').style.display = 'none';
                            browserHistory.replace('/login'); }}
                        >
                            <Translate value="confirm" />
                        </Button>
                    </div>
                </div>}
               </div>
            </Provider>
        );
    }
});

ReactDOM.render(<Root />,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./master/jsx/App.jsx